import { Box } from "@outschool/backpack";
import { TrackingPageSection } from "@outschool/ui-legacy-component-library";
import React from "react";

import useBanners from "../hooks/useBanners";
import PromotionBanner from "./PromotionBanner";

export default function HomePageBanner({
  isFullWidth = false,
}: {
  isFullWidth?: boolean;
}) {
  const bannerRef = React.useRef<HTMLDivElement | null>(null);
  // TODO: abstract this out when migrating to ssr
  const topBanner = useBanners(
    "LoggedOutHome Top",
    [<PromotionBanner isFullWidth={isFullWidth} ref={bannerRef} />],
    isFullWidth
  );

  return (
    <Box>
      {!!topBanner && (
        <TrackingPageSection
          name="logged_out_marketing_banner"
          uniqueId="logged_out_marketing_banner"
        >
          {setImpressionNode => (
            <Box
              ref={setImpressionNode}
              sx={{
                marginX: isFullWidth ? "0px" : "20px",
              }}
            >
              <topBanner.Component />
            </Box>
          )}
        </TrackingPageSection>
      )}
    </Box>
  );
}
